/**
 * @file index.tsx
 *
 * @fileoverview Renders organization boxes label.
 *  Uses h2 tag, but styling remains as default box label.
 */
import { ReactNode } from 'react';
import { AddLink } from '~/jobiqo/components/Organization/Widgets/AddLink';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { FlexItems } from '~/vcl/atoms/06-layout/03-flex';
import { Text } from '~/vcl/atoms/13-text/03-text';
import styles from './boxLabel.module.scss';

interface OrganizationWidgetsBoxLabelProps {
  /**
   * React children.
   */
  children: ReactNode;
  /**
   * The current organization profile.
   */
  organization?: OrganizationProfile;
  /**
   * The current box id.
   */
  boxId?: string;
}

export function OrganizationWidgetsBoxLabel({
  children,
  organization,
  boxId,
}: OrganizationWidgetsBoxLabelProps) {
  return (
    <FlexItems justifyContent="space-between" alignItems="center">
      <Text
        tag="h2"
        className={styles.boxLabel}
        marginBottom={0}
        paddingBottom={0}
        lineHeight={2}
      >
        {children}
      </Text>
      {boxId && organization && (
        <AddLink organization={organization} boxId={boxId} />
      )}
    </FlexItems>
  );
}
